import React, { useState, useEffect } from "react";
import loaderImage from "../../assets/ring_da.png";
import logo from "../../assets/logoDA.png";

const Loader = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Supprime le loader après 3 secondes (ajuste si nécessaire)
    const timer = setTimeout(() => {
      setVisible(false);
    }, 3500);

    return () => clearTimeout(timer); // Nettoie le timer pour éviter les erreurs
  }, []);

  if (!visible) return null; // Cache complètement le loader après le temps défini

  return (
    <div className="loader-container">
      <img src={loaderImage} alt="Loading..." className="loader" />
      <img src={logo} alt="logo" className="logoLoader" />
    </div>
  );
};

export default Loader;
